module.exports = __webpack_public_path__ + "static/media/sample-club.86ea5a1c.png";